import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { AccessExplainerDetails, AccessType } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessExplainerByIdRequest = DynamicQueryParams & {
	accessId: string;
	type: AccessType;
};

export type GetDataSecurityAccessExplainerByIdResponse = AccessExplainerDetails;

export const getDataSecurityAccessExplainerById =
	createGetEndpoint<GetDataSecurityAccessExplainerByIdRequest, GetDataSecurityAccessExplainerByIdResponse>(
		({ accessId, type, ...rest }) =>
			`/api/v3/salesforce/data-access/explain-access/${type}/${accessId}?${getQueryString(rest)}`
	);
